import React, { FC, PropsWithChildren, ReactElement } from 'react'

import { WithDataName } from 'common/types'
import { ModalLayoutIndex } from 'components/layout/ModalLayout/ModalLayoutIndex'
import {
  PhotoViewerModal,
  PhotoViewerWrapper,
} from 'components/page/PhotoViewer/PhotoViewer.styled'

export const PhotoViewerModalWrapperView: FC<
  {
    onBackClick: () => void
    onContentClick: () => void
    size: {
      width: number
      height: number
    }
    banner: ReactElement | null
  } & WithDataName &
    PropsWithChildren
> = ({ children, onBackClick, onContentClick, size, banner, ...rest }) => {
  return (
    <ModalLayoutIndex
      data-name={rest['data-name']}
      fade={false}
      onBackClick={onBackClick}
      renderContent={(children) => (
        <PhotoViewerModal onClick={onContentClick}>
          <PhotoViewerWrapper size={size}>{children}</PhotoViewerWrapper>
          {banner}
        </PhotoViewerModal>
      )}
    >
      {children}
    </ModalLayoutIndex>
  )
}
